/* eslint-disable import/prefer-default-export */
import moment from 'moment';

export const DEF_SEARCH_PARAM_FH = {
  vehicleIds: [],
  startTime: moment(new Date())
    .subtract(1, 'days')
    .format('YYYY-MM-DD HH:mm:ss'),
  endTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
  groupNames: [],
  dtcAlertType: 'ALL',
};

export const DEF_SEARCH_PARAM_VH_LIVE = {
  startTime: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
  endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
  vehicleIds: [],
};

export const DEF_SEARCH_PARAM_VH_HISTORY = {
  startTime: moment(new Date())
    .subtract(1, 'days')
    .startOf('day')
    .format('YYYY-MM-DD HH:mm:ss'),
  endTime: moment(new Date())
    .subtract(1, 'days')
    .endOf('day')
    .format('YYYY-MM-DD HH:mm:ss'),
  vehicleIds: [],
};

export const fleetTblHeadName = [
  { name: 'Registration No', id: 'registrationId' },
  { name: 'Severe DTC', id: 'dtcAlertSeverity', minWidth: '210px' },
  { name: 'No of Active DTC', id: 'count' },
  {
    name: 'Updated on',
    id: 'dtcAlertDate',
    unitConversion: '(DD-MM-YYYY HH:MM:SS)',
  },
  { name: 'Odometer', id: 'odo', unitConversion: '(kms)' },
  { name: 'Engine Hours', id: 'eh', unitConversion: '(hrs)' },
  { name: 'Health Details', id: 'healthDetails' },
];

export const vehicleTblHeadName = [
  { name: 'DTC', id: 'dtcAlertCode' },
  { name: 'Detail', id: 'dtcAlertDescription', minWidth: '170px' },
  { name: 'Address', id: 'address', className: 'tripstrat' },
  {
    name: 'Updated on',
    id: 'dtcAlertDate',
    unitConversion: '(DD-MM-YYYY HH:MM:SS)',
  },
  {
    name: 'Odo | Engine Hrs',
    id: 'odoEngineHours',
    minWidth: '120px',
    tooltip: () => 'Odo and Eng. Hrs',
  },
  { name: 'RCA', id: 'message' },
  { name: 'Comment', id: 'message' },
  { name: 'Status', id: 'resolvedStatus' },
];

export const prognosisAlerts = [
  {
    name: '',
    id: 'icon',
    minWidth: '40px',
  },
  {
    name: 'Health Parameters',
    id: 'healthParameter',
    tooltip: row => {
      const tooltips = {
        'No. of RPM Overshoots per day':
          'RPM overshoots to be maintained < 3 per day',
        'Engine Oil Temperature':
          'Optimum Engine oil temperature to be maintained',
        'Air pressure in tank': 'Optimum Air pressure in tank to be maintained',
        'Battery voltage': 'Optimum Battery voltage to be maintained',
      };

      return tooltips[row.healthParameter] || '';
    },
  },
  {
    name: 'Date',
    id: 'date',
    minWidth: '170px',
    format: value => (value && moment(value).isValid()
      ? moment.utc(value).format('DD/MM/YYYY h:mm A')
      : value),
  },
  {
    name: 'Prognosis',
    id: 'prognosis',
  },
];

export const DTC_COLORS = {
  STN: '#A70E13',
  SN: '#FF7B00',
  SL: '#8A9297',
};
export const DTC_BG_COLORS = {
  STN: '#FFD2D3',
  SN: '#FF7B0033',
  SL: '#CED8DE',
};

export const DTC_SEVERITY = {
  STN: 'Stop Now',
  SN: 'Service Now',
  SL: 'Service Later',
};
